
module.exports = { 
      attributes: {"title":"siteinfos","sitename":"Rdv-nc","description":"Votre système de réservation de rdv","gacode":"GA","favicon":"/img/favicon.svg","icon":"/img/favicon.svg","page404":{"title":"PAGE 404","text":"Désolé, cette page n'existe pas, enfin, la 404 oui, mais pas celle que vous avez appelé..."},"isInMaintenanceMode":false,"maintenanceContent":"# Nous reviendrons bientôt"},
    
      html: "",
     }